// eslint-disable-next-line import/no-extraneous-dependencies
import { ParsedUrlQuery } from 'querystring';
import { FORCE_EXPERIMENT } from '../../constant/queryParams';
import { UnleashSessionVariants } from './unleash.types';

export const formatUnleashVariantsForDataLayer = (
  unleashSessionVariants: UnleashSessionVariants,
) => {
  return Object.entries(unleashSessionVariants)
    .filter(([, value]) => value?.enabled)
    .map(([campaignId, value]) => ({
      campaign: campaignId,
      variant: value?.payload?.value,
    }));
};

const getExperimentOverrideValue = (experimentID: string, query?: ParsedUrlQuery) => {
  const experimentOverride = (query?.[FORCE_EXPERIMENT] as string)
    ?.split(',')
    ?.find(
      (override) => override.includes(experimentID) || override === 'all:0' || override === 'all:1',
    );

  if (experimentOverride) {
    return experimentOverride.split(':')?.[1];
  }
};

export const isUnleashVariantActive = (
  experimentName: string,
  variantName: string,
  unleashSessionVariants: Record<string, any> | null,
  query: Record<string, string> | ParsedUrlQuery,
) => {
  if (!unleashSessionVariants) return false;

  const experimentSessionValue = unleashSessionVariants?.[experimentName]?.payload?.value;
  const experimentOverrideValue = getExperimentOverrideValue(experimentName, query);

  return (experimentOverrideValue || experimentSessionValue) === variantName;
};

export const getActiveUnleashVariant = (
  experimentName: string,
  unleashSessionVariants: Record<string, any> | null,
  query: Record<string, string> | ParsedUrlQuery,
) => {
  if (!unleashSessionVariants) return '0';

  const experimentSessionValue = unleashSessionVariants?.[experimentName]?.payload?.value;
  const experimentOverrideValue = getExperimentOverrideValue(experimentName, query);

  return experimentOverrideValue || experimentSessionValue || '0';
};
